var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scales"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.5 3C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H4.25L2.07692 9.21538C2.02752 9.33395 1.99652 9.47168 2.00236 9.61978C2.06542 11.2213 3.38326 12.5 5 12.5C6.61674 12.5 7.93458 11.2213 7.99765 9.61978C8.00348 9.47168 7.97248 9.33395 7.92308 9.21538L5.75 4H9.5V14H6C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16C16 14.8954 15.1046 14 14 14H10.5V4H14.25L12.0769 9.21538C12.0275 9.33395 11.9965 9.47168 12.0024 9.61978C12.0654 11.2213 13.3833 12.5 15 12.5C16.6167 12.5 17.9346 11.2213 17.9976 9.61978C18.0035 9.47168 17.9725 9.33395 17.9231 9.21538L15.75 4H16.5C16.7761 4 17 3.77614 17 3.5C17 3.22386 16.7761 3 16.5 3H3.5ZM5 11.5C4.0681 11.5 3.28492 10.8625 3.06296 10H6.93704C6.71508 10.8625 5.9319 11.5 5 11.5ZM5 4.8L6.75 9H3.25L5 4.8ZM6 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H6C5.44772 17 5 16.5523 5 16C5 15.4477 5.44772 15 6 15ZM16.75 9H13.25L15 4.8L16.75 9ZM13.063 10H16.937C16.7151 10.8625 15.9319 11.5 15 11.5C14.0681 11.5 13.2849 10.8625 13.063 10Z",
    fill: "#065B70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScales);
export default __webpack_public_path__ + "static/media/scales.701eae01f9a236a20581b316d7c56b25.svg";
export { ForwardRef as ReactComponent };